
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1602Dialog extends Serenity.EntityDialog<Report_1602Row, any> {
        protected getFormKey() { return Report_1602Form.formKey; }
        protected getIdProperty() { return Report_1602Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1602Row.localTextPrefix; }
        protected getNameProperty() { return Report_1602Row.nameProperty; }
        protected getService() { return Report_1602Service.baseUrl; }
        protected getDeletePermission() { return Report_1602Row.deletePermission; }
        protected getInsertPermission() { return Report_1602Row.insertPermission; }
        protected getUpdatePermission() { return Report_1602Row.updatePermission; }

        protected form = new Report_1602Form(this.idPrefix);

    }
}